import Vue from 'vue'

export default {
  login (data) {
    return Vue.http.post('/login', data)
  },

  logout () {
    return Vue.http.post('/logout', {})
  }
}
